import React from "react";
import PropTypes from "prop-types";
//Material imports
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
//Limitless imports
import { useTranslation } from "@limitless/common/hooks";
import Typography from "@limitless/modern/data-display/typography/Typography";
import DropdownMenu from "@limitless/modern/inputs/dropdown-menu/DropdownMenu";
import { useExpertDashboard, useExpertStats } from "@limitless/expert";
import TrendingUp from "@limitless/icons/TrendingUp";
import TrendingDown from "@limitless/icons/TrendingDown";

const useStyles = makeStyles(() => {
    return {
        headerText: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "end"
        },
        text: {
            marginLeft: "3px"
        },
        icon: {
            marginLeft: "13px",
            paddingTop: "5px"
        }
    };
});

const DashboardGraphHeader = ({
    title,
    fetchMontlyData,
    leftTitle = "",
    rate,
    status,
    monthSuggestionOverride,
    groupSuggestionOverride
}) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { monthSuggestions, month, setMonth, group, setGroup } = useExpertDashboard();

    const { groupSuggestions } = useExpertStats(false, t);

    return (
        <Grid container>
            <Grid container direction="row" justifyContent="space-between" spacing={0}>
                <Grid item md={4}>
                    <Grid>
                        <Typography variant="body2" sx={{ color: theme => theme.palette.text.primary }}>
                            {t(title)}
                        </Typography>
                    </Grid>
                    <Grid style={{ display: "flex", flexDirection: "row", alignItems: "baseline", marginTop: "18px" }}>
                        <Typography variant="h3" sx={{ color: theme => theme.palette.text.primary }}>
                            {leftTitle}
                        </Typography>
                        {rate >= 1 && (
                            <Grid sx={{ display: "flex", alignItems: "end" }}>
                                {status ? (
                                    <TrendingUp
                                        fontSize="small"
                                        className={classes.icon}
                                        sx={{ color: theme => theme.palette.success.light }}
                                    />
                                ) : (
                                    <TrendingDown
                                        fontSize="small"
                                        className={classes.icon}
                                        sx={{ color: theme => theme.palette.error.dark }}
                                    />
                                )}

                                <Typography
                                    variant="caption"
                                    sx={{
                                        color: theme =>
                                            status ? theme.palette.success.light : theme.palette.error.dark,
                                        marginLeft: "4px"
                                    }}
                                >
                                    {`${rate}%`}
                                </Typography>
                                <Typography
                                    variant="caption"
                                    sx={{ color: theme => theme.palette.text.secondary, marginLeft: "4px" }}
                                >
                                    {t("vs previous month")}
                                </Typography>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
                <Grid item className={classes.headerText} md={6}>
                    <Grid item md={3}>
                        <DropdownMenu
                            placeholder="All groups"
                            id="groups"
                            skinny
                            options={groupSuggestionOverride ?? groupSuggestions}
                            isOptionEqualToValue={(option, value) => option.value === value.value}
                            value={group}
                            onChange={(e, group) => {
                                return setGroup(group), fetchMontlyData(month, group);
                            }}
                        />
                    </Grid>
                    <Grid ml={theme => theme.spacing(1)} item md={3}>
                        <DropdownMenu
                            placeholder="This month"
                            id="monthlist"
                            skinny
                            options={monthSuggestionOverride ?? monthSuggestions}
                            value={month ?? null}
                            onChange={(e, month) => {
                                return setMonth(month), fetchMontlyData(month, group);
                            }}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
DashboardGraphHeader.propTypes = {
    title: PropTypes.string,
    leftTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    rate:  PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    status: PropTypes.bool,
    fetchMontlyData: PropTypes.func,
    monthSuggestionOverride: PropTypes.object,
    groupSuggestionOverride: PropTypes.object
};
export default DashboardGraphHeader;
